import { FC } from 'react';

interface LogoProps {
  className?: string;
  size?: number;
}

const Logo: FC<LogoProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center overflow-hidden ${className}`}>
      <img
        src="/images/new_logo.jpg"
        alt="PedigreePro Logo"
        className="h-20 md:h-28 lg:h-32 xl:h-32 2xl:h-36 w-auto max-h-36"
        style={{
          objectFit: 'cover',
          objectPosition: 'center 60%'
        }}
      />
    </div>
  );
};

export default Logo;